<template>
  <div>
    <div class="search-bar">
      <Input v-model="searchQuery" placeholder="搜索模型名称或提供商" clearable style="width: 300px" />
      <Button type="primary" @click="handleSearch" style="margin-left: 10px">搜索</Button>
      <Button type="success" @click="handleAdd" style="margin-left: 10px">新建模型</Button>
      <Button type="info" @click="handlePreset" style="margin-left: 10px">使用预设</Button>
    </div>

    <div class="table-wrapper">
      <BaseTable
        :columns="columns"
        :data="filteredData"
        :loading="loading"
        border
        @event="handleTableEvent"
      ></BaseTable>
    </div>

    <Modal
      v-model="modalVisible"
      :title="modalTitle"
      @on-ok="handleSubmit"
      :loading="confirmLoading"
      width="800"
    >
      <Form ref="formRef" :model="formData" :rules="rules" :label-width="120">
        <FormItem label="预设模板" v-if="!currentId">
          <Select v-model="presetTemplate" placeholder="选择预设模板快速填充" clearable @on-change="handlePresetSelect" style="width: 100%">
            <Option v-for="preset in presetOptions" :key="preset.key" :value="preset.key">
              {{ preset.name }}
            </Option>
          </Select>
        </FormItem>

        <FormItem label="名称" prop="name">
          <Input v-model="formData.name" placeholder="请输入模型名称" />
        </FormItem>

        <FormItem label="类型" prop="type">
          <Select v-model="formData.type" placeholder="请选择类型" style="width: 100%">
            <Option value="agent">智能体</Option>
            <Option value="model">大模型</Option>
            <Option value="workflow">工作流</Option>
          </Select>
        </FormItem>

        <FormItem label="提供商" prop="provider">
          <Input v-model="formData.provider" placeholder="请输入提供商名称" />
        </FormItem>

        <FormItem label="头像URL" prop="avatar">
          <Input v-model="formData.avatar" placeholder="请输入头像URL" />
        </FormItem>

        <FormItem label="Base URL" prop="base_url">
          <Input v-model="formData.base_url" placeholder="请输入Base URL" />
        </FormItem>

        <FormItem label="File URL">
          <Input v-model="formData.file_url" placeholder="请输入File URL（可选）" />
        </FormItem>

        <FormItem label="模型" prop="model">
          <Input v-model="formData.model" placeholder="请输入模型名称" />
        </FormItem>

        <FormItem label="API Key" prop="api_key">
          <Input v-model="formData.api_key" type="password" placeholder="请输入API Key" />
        </FormItem>

        <FormItem label="API ID">
          <Input v-model="formData.api_id" placeholder="请输入API ID（可选）" />
        </FormItem>

        <div class="form-row">
          <FormItem label="OpenAI兼容" class="form-item">
            <i-switch v-model="formData.openai" :true-value="true" :false-value="false" />
          </FormItem>
          <FormItem label="支持视觉" class="form-item">
            <i-switch v-model="formData.vision" :true-value="true" :false-value="false" />
          </FormItem>
        </div>

        <div class="form-row">
          <FormItem label="支持推理" class="form-item">
            <i-switch v-model="formData.reasoner" :true-value="true" :false-value="false" />
          </FormItem>
          <FormItem label="函数调用" class="form-item">
            <i-switch v-model="formData.function_call" :true-value="true" :false-value="false" />
          </FormItem>
        </div>

        <div class="form-row">
          <FormItem label="图像生成" class="form-item">
            <i-switch v-model="formData.image_generation" :true-value="true" :false-value="false" />
          </FormItem>
          <div class="form-item"></div>
        </div>
      </Form>
    </Modal>

    <Modal
      v-model="presetModalVisible"
      title="选择预设模板"
      width="600"
      @on-ok="handlePresetConfirm"
    >
      <div class="preset-list">
        <div
          v-for="preset in presetOptions"
          :key="preset.key"
          class="preset-item"
          @click="selectedPreset = preset.key"
          :class="{ active: selectedPreset === preset.key }"
        >
          <div class="preset-header">
            <img v-if="preset.avatar" :src="preset.avatar" class="preset-avatar" />
            <div class="preset-info">
              <h4>{{ preset.name }}</h4>
              <span class="preset-type">{{ getTypeLabel(preset.type) }}</span>
            </div>
          </div>
          <div class="preset-details">
            <p><strong>Base URL:</strong> {{ preset.base_url }}</p>
            <p v-if="preset.model"><strong>Model:</strong> {{ preset.model }}</p>
            <p v-if="preset.openai"><strong>OpenAI兼容:</strong> 是</p>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      providers: [],
      searchQuery: '',
      loading: false,
      confirmLoading: false,
      modalVisible: false,
      modalTitle: '添加模型',
      currentId: null,
      presetModalVisible: false,
      selectedPreset: null,
      presetTemplate: null,
      formData: this.getInitialFormData(),
      presetOptions: [
        {
          key: 'coze-agent',
          name: 'COZE-智能体',
          type: 'agent',
          provider: 'COZE',
          base_url: 'https://api.coze.cn/v3/chat',
          avatar: 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/cdn/logo/coze.png',
          model: '',
          openai: false,
        },
        {
          key: 'coze-workflow',
          name: 'COZE-工作流',
          type: 'workflow',
          provider: 'COZE',
          base_url: 'https://api.coze.cn/v1/workflow/run',
          avatar: 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/cdn/logo/coze.png',
          model: '',
          openai: false,
        },
        {
          key: 'hunyuan',
          name: '腾讯混元-openai',
          type: 'model',
          provider: '腾讯混元',
          base_url: 'http://localhost:6005/ai/hunyuan/',
          avatar: 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/cdn/logo/hunyuan.png',
          model: '',
          openai: true,
        },
        {
          key: 'huoshan',
          name: '火山大模型',
          type: 'model',
          provider: '火山引擎',
          base_url: 'https://ark.cn-beijing.volces.com/api/v3/chat/completions',
          avatar: 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/cdn/logo/huoshan.png',
          model: '',
          openai: false,
        },
        {
          key: 'deepseek',
          name: 'deepseek',
          type: 'model',
          provider: 'DeepSeek',
          base_url: 'https://api.deepseek.com/chat/completions',
          avatar: 'https://nbgzfiles-1257839135.cos.ap-shanghai.myqcloud.com/cdn/logo/deepseek.png',
          model: '',
          openai: false,
        },
      ],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        provider: [{ required: true, message: '请输入提供商', trigger: 'blur' }],
        base_url: [{ required: true, message: '请输入Base URL', trigger: 'blur' }],
        model: [{ required: true, message: '请输入模型名称', trigger: 'blur' }],
        api_key: [{ required: true, message: '请输入API Key', trigger: 'blur' }],
      },
      columns: [
        { type: 'index', width: 80, title: '序号' },
        {
          title: '头像',
          key: 'avatar',
          width: 80,
          align: 'center',
          render: (h, params) => {
            if (params.row.avatar) {
              return h('img', {
                attrs: {
                  src: params.row.avatar,
                  alt: params.row.name,
                },
                style: {
                  width: '40px',
                  height: '40px',
                  borderRadius: '4px',
                  objectFit: 'cover',
                },
              });
            }
            return h('span', { style: { color: '#ccc' } }, '-');
          },
        },
        {
          title: '名称',
          key: 'name',
          minWidth: 150,
        },
        {
          title: '类型',
          key: 'type',
          width: 100,
          render: (h, params) => {
            const typeMap = {
              agent: { text: '智能体', color: 'blue' },
              model: { text: '大模型', color: 'green' },
              workflow: { text: '工作流', color: 'orange' },
            };
            const type = typeMap[params.row.type] || { text: '未知', color: 'default' };
            return h('Tag', { props: { color: type.color } }, type.text);
          },
        },
        {
          title: '提供商',
          key: 'provider',
          minWidth: 120,
        },
        {
          title: '模型',
          key: 'model',
          minWidth: 150,
        },
        {
          title: 'Base URL',
          key: 'base_url',
          minWidth: 200,
          render: (h, params) => {
            if (!params.row.base_url) return h('span', { style: { color: '#ccc' } }, '-');
            return h('span', {
              style: {
                fontFamily: 'monospace',
                fontSize: '12px',
                background: '#f5f5f5',
                padding: '2px 6px',
                borderRadius: '3px',
              },
            }, params.row.base_url);
          },
        },
        {
          title: '功能',
          key: 'features',
          width: 200,
          render: (h, params) => {
            const features = [];
            if (params.row.openai) {
              features.push(h('Tag', { props: { color: 'blue', size: 'small' }, style: { marginRight: '4px' } }, 'OpenAI'));
            }
            if (params.row.vision) {
              features.push(h('Tag', { props: { color: 'green', size: 'small' }, style: { marginRight: '4px' } }, '视觉'));
            }
            if (params.row.reasoner) {
              features.push(h('Tag', { props: { color: 'purple', size: 'small' }, style: { marginRight: '4px' } }, '推理'));
            }
            if (params.row.function_call) {
              features.push(h('Tag', { props: { color: 'orange', size: 'small' }, style: { marginRight: '4px' } }, '函数'));
            }
            if (params.row.image_generation) {
              features.push(h('Tag', { props: { color: 'magenta', size: 'small' }, style: { marginRight: '4px' } }, '图像'));
            }
            return h('div', features.length > 0 ? features : h('span', { style: { color: '#ccc' } }, '-'));
          },
        },
        { type: 'time', title: '创建时间', key: 'created_at', width: 180 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handleEdit(params.row);
                  },
                },
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                style: {
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handleDelete(params.row);
                  },
                },
              }, '删除'),
            ]);
          },
        },
      ],
    };
  },
  computed: {
    filteredData() {
      if (!this.searchQuery) {
        return this.providers;
      }
      const query = this.searchQuery.toLowerCase();
      return this.providers.filter(
        (item) =>
          (item.name && item.name.toLowerCase().includes(query)) ||
          (item.provider && item.provider.toLowerCase().includes(query)) ||
          (item.model && item.model.toLowerCase().includes(query)),
      );
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    getInitialFormData() {
      return {
        name: '',
        type: '',
        provider: '',
        avatar: '',
        base_url: '',
        file_url: '',
        model: '',
        api_key: '',
        api_id: '',
        openai: false,
        vision: false,
        reasoner: false,
        function_call: false,
        image_generation: false,
      };
    },
    getTypeLabel(type) {
      const typeMap = {
        agent: '智能体',
        model: '大模型',
        workflow: '工作流',
      };
      return typeMap[type] || type;
    },
    handleSearch() {
      // 搜索逻辑已在computed中处理
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await this.$api.get('/admin/ai-models');
        this.providers = response.data.data || [];
      } catch (error) {
        this.$Message.error('获取模型列表失败');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleTableEvent(e) {
      const { type, data } = e;
      // 处理表格事件
    },
    handleAdd() {
      this.modalTitle = '添加模型';
      this.formData = this.getInitialFormData();
      this.currentId = null;
      this.presetTemplate = null;
      this.modalVisible = true;
    },
    handleEdit(record) {
      this.modalTitle = '编辑模型';
      this.formData = { ...record };
      this.currentId = record.id;
      this.presetTemplate = null;
      this.modalVisible = true;
    },
    async handleDelete(record) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除模型 "${record.name}" 吗？此操作不可恢复。`,
        onOk: async () => {
          try {
            await this.$api.delete(`/admin/ai-models/${record.id}`);
            this.$Message.success('删除成功');
            this.fetchData();
          } catch (error) {
            this.$Message.error('删除失败');
            console.error(error);
          }
        },
      });
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        this.confirmLoading = true;

        const submitData = { ...this.formData };
        // 移除id字段，后端会自动生成
        if (!this.currentId) {
          delete submitData.id;
        }

        if (this.currentId) {
          // 更新
          await this.$api.patch(`/admin/ai-models/${this.currentId}`, submitData);
          this.$Message.success('更新成功');
        } else {
          // 新增
          await this.$api.post('/admin/ai-models', submitData);
          this.$Message.success('添加成功');
        }

        this.modalVisible = false;
        this.fetchData();
      } catch (error) {
        if (error.message !== 'validation') {
          this.$Message.error(error.message || '提交失败');
        }
        console.error(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    handlePreset() {
      this.presetModalVisible = true;
      this.selectedPreset = null;
    },
    handlePresetConfirm() {
      if (!this.selectedPreset) {
        this.$Message.warning('请选择一个预设模板');
        return;
      }
      const preset = this.presetOptions.find((p) => p.key === this.selectedPreset);
      if (preset) {
        this.formData = {
          ...this.getInitialFormData(),
          ...preset,
        };
        this.currentId = null;
        this.modalTitle = '添加模型';
        this.modalVisible = true;
        this.presetModalVisible = false;
      }
    },
    handlePresetSelect(value) {
      if (!value) return;
      const preset = this.presetOptions.find((p) => p.key === value);
      if (preset) {
        this.formData = {
          ...this.getInitialFormData(),
          ...preset,
        };
      }
    },
  },
};
</script>

<style lang="less" scoped>
.search-bar {
  border-bottom: 1px solid var(--border);
  padding: 15px;
  background: #fff;
  display: flex;
  align-items: center;
}

.table-wrapper {
  position: relative;
  height: calc(100vh - 100px);
  overflow: auto;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.form-row {
  display: flex;
  margin: 0 -8px;
}

.form-item {
  padding: 0 8px;
  flex: 1;
}

.preset-list {
  max-height: 500px;
  overflow-y: auto;
}

.preset-item {
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 16px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: var(--primary);
    background: #f0f7ff;
  }

  &.active {
    border-color: var(--primary);
    background: #e6f7ff;
  }
}

.preset-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.preset-avatar {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  margin-right: 12px;
  object-fit: cover;
}

.preset-info {
  flex: 1;

  h4 {
    margin: 0 0 4px 0;
    font-size: 16px;
    font-weight: 600;
  }

  .preset-type {
    font-size: 12px;
    color: #666;
    background: #f0f0f0;
    padding: 2px 8px;
    border-radius: 3px;
  }
}

.preset-details {
  p {
    margin: 4px 0;
    font-size: 13px;
    color: #666;

    strong {
      color: #333;
      margin-right: 8px;
    }
  }
}
</style>
